import { render, staticRenderFns } from "./RecepcionSolicitudes.vue?vue&type=template&id=64fcbada"
import script from "./RecepcionSolicitudes.vue?vue&type=script&lang=js"
export * from "./RecepcionSolicitudes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports